import { render, staticRenderFns } from "./TruckDisplay.vue?vue&type=template&id=19147484&"
import script from "./TruckDisplay.vue?vue&type=script&lang=js&"
export * from "./TruckDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports